import { Suspense } from "react";
import SparkShell from "../SparkShell.jsx";
import RouteBoundary from "../../../lib/RouteBoundary";
import { HeaderLessShell } from "../../shell/Shell.jsx";
import { WorkshopUserTourProvider } from "./context/WorkshopUserTourContext.jsx";

/**
 * A higher-order component that provides a workshop tour context to the SparkShell component.
 *
 * This component wraps the `SparkShell` component with the `WorkshopTourProvider` context,
 * enabling `SparkShell` to have access to any functionality, state, or features provided
 * by the `WorkshopTourProvider`.
 *
 * @param {Object} props - The properties passed to the SparkShell component.
 * @returns {JSX.Element} A JSX element that includes the SparkShell component wrapped with the WorkshopTourProvider.
 */
const SparkShellWithWorkshopTourProvider = (props) => {
  return (
    // Outer layer: the workshop fetch is shell-defining, so 404/error render in
    // neutral chrome and loading shows a neutral skeleton (not the suspending shell).
    <RouteBoundary Shell={HeaderLessShell}>
      <WorkshopUserTourProvider>
        <Suspense fallback={<HeaderLessShell isLoading />}>
          <SparkShell {...props} />
        </Suspense>
      </WorkshopUserTourProvider>
    </RouteBoundary>
  );
};

export default SparkShellWithWorkshopTourProvider;
